<div class="ml-72 mr-72 pt-24 update-build-container">
  <app-breadcrumb class="mt-16" [items]="breadcrumbItems"></app-breadcrumb>
  <div class="flex flex-row justify-start items-center p-24 mb-24 top-panel">
    <mat-icon svgIcon="arrow_back" class="cursor-pointer icon-lg" (click)="goToInstances()"></mat-icon>
    <div class="flex flex-col ml-24 w-100-percent">
      <div class="flex justify-between items-center">
        <div class="mat-headline-5 fw-600">{{data?.name}}</div>
        <div class="flex items-center justify-between fw-600 fs-16">
          <span>
            <mat-icon *ngIf="completedStatus.includes(data?.status)" svgIcon="done" class="icon-md p-2 mr-6" [ngClass]="data?.status"></mat-icon>
            <mat-icon *ngIf="terminateStatus.includes(data?.status)" svgIcon="error_outline" class="icon-md p-2 mr-6" [ngClass]="data?.status"></mat-icon>
            <mat-icon *ngIf="errorStatus.includes(data?.status)" svgIcon="close" class="icon-md p-2 mr-6" [ngClass]="data?.status"></mat-icon>
            <mat-icon *ngIf="inprogressStatus.includes(data?.status)" svgIcon="change_circle" class="icon-md p-2 mr-6" [ngClass]="data?.status"></mat-icon>
          </span>
          <span>{{data?.status | titlecase}}</span>
        </div>
      </div>
      <div class="instance-details mat-body fw-400">
        <span class="mr-2">{{'INSTANCE_DETAILS.SERVICE_DEFINITION' | transloco}}:</span>
        {{serviceName ? serviceName : '-'}}
        <span class="vertical-dash pl-10 ml-10">
          {{'INSTANCE_DETAILS.RELEASE_VERSION' | transloco }}:
          <span class="ml-2">{{taskInfo?.releaseVersion ? taskInfo?.releaseVersion : '-'}}</span>
          <span *ngIf="solutionVersionsService.releaseVersion(taskInfo?.releaseVersion)">&nbsp;|&nbsp;
            {{('INSTANCE_DETAILS.AMR' | transloco)}}
          </span>
        </span>
        <span class="vertical-dash pl-10 ml-10">
          {{'INSTANCE_DETAILS.BUILD_VERSION' | transloco }} :
          {{taskInfo?.version ? taskInfo?.version : '-'}}
        </span>
      </div>
    </div>
  </div>
  <div class="flex items-center">
    <div class="flex items-center justify-center" [ngClass]="{'current-tab': currentStep === 1, 'not-visited': !visitedSteps.stepOne}">
      <span class="count-border flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center">1</span></span>
      <span class="mat-subtitle-2 fw-500 tab-name">{{'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_RELEASE_VERSION' | transloco}}</span><span class="horizontal-line ml-12 mr-12"></span>
    </div>
    <div class="flex items-center justify-center" [ngClass]="{'current-tab': currentStep === 2, 'not-visited': !visitedSteps.stepTwo}">
      <span class="count-border flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center">2</span></span>
      <span class="mat-subtitle-2 fw-500 tab-name">{{'INSTANCE_DETAILS.UPDATE_BUILD.EXTERNAL_PACKAGE' | transloco}}</span><span class="horizontal-line ml-12 mr-12"></span>
    </div>
    <div class="flex items-center justify-center" [ngClass]="{'current-tab': currentStep === 3, 'not-visited': !visitedSteps.stepThree}">
      <span class="count-border flex items-center justify-center mr-8"><span class="mat-subtitle-2 fw-700 fs-14 count flex items-center justify-center">3</span></span>
      <span class="mat-subtitle-2 fw-500 tab-name">{{'INSTANCE_DETAILS.UPDATE_BUILD.SUMMARY' | transloco}}</span>
    </div>
  </div>

  <mat-divider class="mb-16 mt-16 neutral-2"></mat-divider>

  <div *ngIf="currentStep === 1" class="w-100-percent section-border p-24">
    <div class="flex flex-row mat-subtitle-2 fw-700 fs-12" [ngClass]="{'not-selected': !selectedVersion}">
      {{'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_RELEASE_VERSION' | transloco | uppercase}}
      <mat-icon svgIcon="info" class="icon-sm mt-2 ml-10" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_RELEASE_VERSION' | transloco"
        matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
    </div>
    <div class="mat-body fw-500 pt-8" [ngClass]="{'not-selected': !selectedVersion}">
      <mat-select class="fw-500 form-select" placeholder="{{'INSTANCE_DETAILS.UPDATE_BUILD.CHOOSE' | transloco}}" [(value)]="selectedVersion" panelClass="update-dropdown" (selectionChange)="versionChanged($event.value)" (click)="onClick()">
        <mat-option *ngFor="let version of versionData" [value]="version.version">{{version.version}}</mat-option>
      </mat-select>
    </div>
  </div>

  <div *ngIf="currentStep === 2" class="w-100-percent section-border p-24">
    <div class="flex flex-col mat-subtitle-2 fw-700 fs-12 mb-24">
      <div class="flex mb-8" [ngClass]="{'not-selected': !selectedExternalPackage}">{{'INSTANCE_DETAILS.UPDATE_BUILD.EXTERNAL_PACKAGE' | transloco | uppercase}}
        <mat-icon svgIcon="info" class="icon-sm mt-2 ml-10" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.UPDATE_BUILD.EXTERNAL_PACKAGE' | transloco"
          matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
      </div>
      <div [ngClass]="{'not-selected': !selectedExternalPackage}">
        <mat-select class="fw-500 form-select" placeholder="{{'INSTANCE_DETAILS.UPDATE_BUILD.CHOOSE' | transloco}}" [(value)]="selectedExternalPackage" panelClass="update-dropdown" (click)="onClickPackage()" (selectionChange)="externalPackageChanged($event.value)">
          <div class="flex search-bar m-8"><input [(ngModel)]="searchValue" (ngModelChange)="searchChanged(searchValue)" class="fw-400 h-34 no-border pl-12" placeholder="Search" type="text">
            <span (click)="searchChanged(searchValue)" class="cursor-pointer"><mat-icon class="mr-8 icon-md icon-color mt-4 mr-10" svgIcon="search"></mat-icon></span>
          </div>
          <div class="ml-16 mr-16 mt-8 mb-8" *ngIf="filteredExternalPackages?.length === 0">{{'INSTANCE_DETAILS.UPDATE_BUILD.NO_ITEMS_FOUND' | transloco}}</div>
          <mat-option *ngFor="let package of filteredExternalPackages" [value]="package" [title]="package?.name">{{package?.name | titlecase}}</mat-option>
        </mat-select>
      </div>
    </div>
    <div class="flex flex-col endpoints update-build">
      <div *ngIf="selectedExternalPackage?.references?.length > 0; else noDataFound" class="flex flex-col border-radius">
        <div class="component-header mat-body-2 fw-700 pl-50 flex items-center">{{'INSTANCE_DETAILS.UPDATE_BUILD.COMPONENT' | transloco | uppercase }}</div>
        <mat-accordion #accordion [togglePosition]="'before'" [multi]="false">
          <ng-container *ngFor="let component of selectedExternalPackage?.references">
            <mat-expansion-panel (afterExpand)="onArrowClick(component)">
              <mat-expansion-panel-header class="component">
                <mat-panel-title>
                  <span class="mat-body-1 fw-500">{{ component?.component | titlecase }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex flex-row w-100-percent gap-4">
                <div class="table-section package-sections p-16">
                  <span class="mat-body-2 fw-600 flex mb-12">{{'INSTANCE_DETAILS.UPDATE_BUILD.IMAGES' | transloco}}</span>
                  <ng-container *ngIf="dataSourceInner?.length > 0; else noInnerDataFound">
                    <div class="table-scroll">
                      <table mat-table [dataSource]="dataSourceInner" multiTemplateDataRows class="mat-elevation ext-package">
                        <ng-container matColumnDef="name">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name">{{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 name">
                            <div class="overflow" title="{{data?.name | titlecase}}">{{data?.name | titlecase}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="path">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path">{{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 path"><div class="overflow" title="{{data?.path | titlecase}}">{{data?.path ? (data?.path | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="currentVersion">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.CURRENT_VERSION' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4" [ngClass]="{'current-version': data?.currentVersion}">{{data?.currentVersion ? (data?.currentVersion | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="targetVersion">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_VERSION' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4" [ngClass]="{'target-version': data?.version}">{{data?.version ? (data?.version | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                      </table>
                    </div>
                  </ng-container>
                </div>
                <div class="table-section package-sections p-16">
                  <span class="mat-body-2 fw-600 flex mb-12">{{'INSTANCE_DETAILS.UPDATE_BUILD.PACKAGES' | transloco}}</span>
                  <ng-container *ngIf="dataSourceInnerPackages?.length > 0; else noInnerDataFound">
                    <div class="table-scroll">
                      <table mat-table [dataSource]="dataSourceInnerPackages" multiTemplateDataRows class="mat-elevation ext-package">
                        <ng-container matColumnDef="name">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 name">
                            <div class="overflow" title="{{data?.name | titlecase}}">{{data?.name | titlecase}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="path">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 path"><div class="overflow" title="{{data?.path | titlecase}}">{{data?.path ? (data?.path | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="currentVersion">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.CURRENT_VERSION' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4" [ngClass]="{'current-version': data?.currentVersion}">{{data?.currentVersion ? (data?.currentVersion | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="targetVersion">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_VERSION' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4" [ngClass]="{'target-version': data?.version}">{{data?.version ? (data?.version | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                      </table>
                    </div>
                  </ng-container>
                </div>
              </div>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
      </div>
      <ng-template #noDataFound>
        <div *ngIf="selectedExternalPackage" class="flex justify-center pt-8 pb-8 fw-400">
          {{'INSTANCE_DETAILS.UPDATE_BUILD.NO_COMPONENTS_AVALIABLE' | transloco }}
        </div>
      </ng-template>
      <ng-template #noInnerDataFound>
        <div>
          <table [dataSource]="dataSourceInnerLog" mat-table class="mat-elevation ext-package">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
            </ng-container>
            <ng-container matColumnDef="path">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
            </ng-container>
            <ng-container matColumnDef="currentVersion">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.CURRENT_VERSION' | transloco | uppercase }} </th>
            </ng-container>
            <ng-container matColumnDef="targetVersion">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_VERSION' | transloco | uppercase }} </th>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
          </table>
          <div class="flex justify-center items-center fw-500 mb-20 no-data">
            {{'INSTANCE_DETAILS.UPDATE_BUILD.NO_DATA_AVAILABLE' | transloco }}
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <div *ngIf="currentStep === 3" class="w-100-percent section-border p-24">
    <div class="flex flex-row items-center justify-between mat-subtitle-2 fw-700 fs-14 mb-8">
      <div class="flex">{{'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_RELEASE_VERSION' | transloco | uppercase}}
      </div>
      <div class="flex flex-col" (click)="goToStep(currentStep - 2)">
        <button class="menu-button">
          <div class="flex flex-row justify-start items-center">
            <mat-icon svgIcon="edit" class="icon-md mr-10"></mat-icon>
            <div class="mat-subtitle-2 mb-0 fw-700 fs-20">{{'SOLUTIONS.EDIT' | transloco }}</div>
          </div>
        </button>
      </div>
    </div>
    <span>{{selectedVersion}}</span>

    <mat-divider class="mb-16 mt-16 neutral-2 divider-width"></mat-divider>

    <div class="flex flex-row items-center justify-between mat-subtitle-2 fw-700 fs-14 mb-8">
      <div class="flex">{{ selectedExternalPackage ? (selectedExternalPackage?.name | uppercase) : ('INSTANCE_DETAILS.UPDATE_BUILD.NO_EXTERNAL_PACKAGE_SELECTED' | transloco | uppercase)}}
      </div>
      <div class="flex flex-col" (click)="goToStep(currentStep - 1)">
        <button class="menu-button">
          <div class="flex flex-row justify-start items-center">
            <mat-icon svgIcon="edit" class="icon-md mr-10"></mat-icon>
            <div class="mat-subtitle-2 mb-0 fw-700 fs-20">{{'SOLUTIONS.EDIT' | transloco }}</div>
          </div>
        </button>
      </div>
    </div>

    <div class="flex flex-col endpoints update-build">
      <div *ngIf="selectedExternalPackage?.references?.length > 0; else noDataFound" class="flex flex-col border-radius">
        <div class="component-header mat-body-2 fw-700 pl-50 flex items-center">{{'INSTANCE_DETAILS.UPDATE_BUILD.COMPONENT' | transloco | uppercase }}</div>
        <mat-accordion #accordion [togglePosition]="'before'" [multi]="false">
          <ng-container *ngFor="let component of selectedExternalPackage?.references">
            <mat-expansion-panel (afterExpand)="onArrowClick(component)">
              <mat-expansion-panel-header class="component">
                <mat-panel-title>
                  <span class="mat-body-1 fw-500">{{ component?.component | titlecase }}</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="flex flex-row w-100-percent gap-4">
                <div class="table-section package-sections p-16">
                  <span class="mat-body-2 fw-600 flex mb-12">{{'INSTANCE_DETAILS.UPDATE_BUILD.IMAGES' | transloco}}</span>
                  <ng-container *ngIf="dataSourceInner?.length > 0; else noInnerDataFound">
                    <div class="table-scroll">
                      <table mat-table [dataSource]="dataSourceInner" multiTemplateDataRows class="mat-elevation ext-package">
                        <ng-container matColumnDef="name">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name">{{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 name">
                            <div class="overflow" title="{{data?.name | titlecase}}">{{data?.name | titlecase}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="path">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path">{{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }}</th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 path"><div class="overflow" title="{{data?.path | titlecase}}">{{data?.path ? (data?.path | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="currentVersion">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.CURRENT_VERSION' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4" [ngClass]="{'current-version': data?.currentVersion}">{{data?.currentVersion ? (data?.currentVersion | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="targetVersion">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_VERSION' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4" [ngClass]="{'target-version': data?.version}">{{data?.version ? (data?.version | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                      </table>
                    </div>
                  </ng-container>
                </div>
                <div class="table-section package-sections p-16">
                  <span class="mat-body-2 fw-600 flex mb-12">{{'INSTANCE_DETAILS.UPDATE_BUILD.PACKAGES' | transloco}}</span>
                  <ng-container *ngIf="dataSourceInnerPackages?.length > 0; else noInnerDataFound">
                    <div class="table-scroll">
                      <table mat-table [dataSource]="dataSourceInnerPackages" multiTemplateDataRows class="mat-elevation ext-package">
                        <ng-container matColumnDef="name">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 name">
                            <div class="overflow" title="{{data?.name | titlecase}}">{{data?.name | titlecase}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="path">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 path"><div class="overflow" title="{{data?.path | titlecase}}">{{data?.path ? (data?.path | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="currentVersion">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.CURRENT_VERSION' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4" [ngClass]="{'current-version': data?.currentVersion}">{{data?.currentVersion ? (data?.currentVersion | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <ng-container matColumnDef="targetVersion">
                          <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_VERSION' | transloco | uppercase }} </th>
                          <td mat-cell *matCellDef="let data" class="route-id cell-data fw-500 fs-16 version"><div class="p-4" [ngClass]="{'target-version': data?.version}">{{data?.version ? (data?.version | titlecase) : '-'}}</div></td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
                      </table>
                    </div>
                  </ng-container>
                </div>
              </div>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
      </div>
      <ng-template #noDataFound>
        <div *ngIf="selectedExternalPackage" class="flex justify-center pt-8 pb-8 fw-400">
          {{'INSTANCE_DETAILS.UPDATE_BUILD.NO_COMPONENTS_AVALIABLE' | transloco }}
        </div>
      </ng-template>
      <ng-template #noInnerDataFound>
        <div>
          <table [dataSource]="dataSourceInnerLog" mat-table class="mat-elevation ext-package">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 name"> {{'INSTANCE_DETAILS.UPDATE_BUILD.NAME' | transloco | uppercase }} </th>
            </ng-container>
            <ng-container matColumnDef="path">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 path"> {{'INSTANCE_DETAILS.UPDATE_BUILD.PATH' | transloco | uppercase }} </th>
            </ng-container>
            <ng-container matColumnDef="currentVersion">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.CURRENT_VERSION' | transloco | uppercase }} </th>
            </ng-container>
            <ng-container matColumnDef="targetVersion">
              <th mat-header-cell *matHeaderCellDef class="fs-14 fw-700 version"> {{'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_VERSION' | transloco | uppercase }} </th>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="innerTableColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: innerTableColumns;"></tr>
          </table>
          <div class="flex justify-center items-center fw-500 mb-20 no-data">
            {{'INSTANCE_DETAILS.UPDATE_BUILD.NO_DATA_AVAILABLE' | transloco }}
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<div class="summary-header pl-80 pr-80">
  <div class="flex flex-row justify-between items-center">
    <div class="flex items-center">
      <mat-icon svgIcon="arrow_back" class="icon-sm cursor-pointer mr-8" (click)="currentStep === 1 ? goToInstances() : goToStep(currentStep - 1)"></mat-icon>
      <div class="mat-subtitle-2 fw-700 mb-0 cursor-pointer" (click)="currentStep === 1 ? goToInstances() : goToStep(currentStep - 1)">
        {{ 'BUTTONS.PREVIOUS' | transloco }}
      </div>
      <button class="flex justify-center items-center blend-border cancel-btn ml-24 p-16 pl-42 pr-42" (click)="goToInstances()">
        <mat-icon svgIcon="close" class="icon-sm cursor-pointer mr-8"></mat-icon>
        {{ 'BUTTONS.CANCEL' | transloco }}
      </button>
    </div>
    <div class="flex">
      <button *ngIf="currentStep === 2" class="flex justify-center items-center blend-border cancel-btn mr-24 p-16 pl-42 pr-42" (click)="goToStep(currentStep + 1, true)">
        {{ 'INSTANCE_DETAILS.UPDATE_BUILD.SKIP_THIS_STEP' | transloco }}
      </button>
      <button
        *ngIf="currentStep !== stepsArray.length"
        class="flex justify-center items-center mossgreen primary-fg p-16 pl-42 pr-42" type="button"
        (click)="goToStep(currentStep + 1)" [disabled]="(currentStep === 1 && !selectedVersion) || (currentStep === 2 && !selectedExternalPackage)">{{ 'BUTTONS.NEXT' | transloco }}
        <mat-icon svgIcon="arrow_forward" class="icon-sm ml-8"></mat-icon>
      </button>
      <button
        *ngIf="currentStep === stepsArray.length"
        class="flex justify-center items-center mossgreen primary-fg p-16 pl-42 pr-42" type="button"
        (click)="updateBuild()">{{ 'BUTTONS.UPDATE' | transloco }}
      </button>
    </div>
  </div>
</div>
